
import gql from 'graphql-tag'
import userFavProductWLCI from '@/apollo/queries/user/userFavProductWLCI'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import wlciTooltips from '~/apollo/queries/product/tooltips/wlciTooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "FavProductWLCICard",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductWLCI} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.wlciScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: wlciTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).WLCI;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            const planName = item.attributes.wlci_plan.data.attributes.wlci_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.wlci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
            const link = this.currentLink;
            let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.wlci.wlci_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
            let decoderCTAText = '';

            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.wlci_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.wlci_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                decoderCTAText = this.$t('products.product_website');
              }
            }

            const filteredTranslations = this.getFilteredTranslations(item.attributes.wlci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              scenario_code: item.attributes.scenario_code,
              payment_term: item.attributes.payment_term,
              annual_premium: item.attributes.annual_premium,
              currency: item.attributes.currency.data.attributes.code,

              // // plan
              plan_code: item.attributes.wlci_plan.data.attributes.plan_code,
              coverage_score: item.attributes.wlci_plan.data.attributes.coverage_score,
              terms_score: item.attributes.wlci_plan.data.attributes.terms_score,



              overall_star: item.attributes.wlci_plan.data.attributes.overall_star,
              plan_name: item.attributes.wlci_plan.data.attributes.wlci_plan_translations.data[0].attributes.name,

              multiple_claim: item.attributes.wlci_plan.data.attributes.wlci_multiple_claim.data.attributes.wlci_multiple_claim_translations.data[0].attributes.description,
              // insurer
              insurer_name_first: item.attributes.wlci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
              insurer_name_second: filteredTranslations[0].attributes.name,
              insurer_logo: item.attributes.wlci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
              insurer_code: item.attributes.wlci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

              product_promotion: promotion,
              promotion_last_call: promotion_last_call,

              decoder_cta_link: decoderCTALink,
              decoder_cta_text: decoderCTAText,
              scenarioID: item.id,
            };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        return {
          favProductId: this.favProductId,
          scenarioId: this.simpleItem.scenarioID,
          id: this.simpleItem.scenario_code,
          productType: "whole-life-critical-illness",
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItem.overall_star),
          showTrending: false,

          productLink: this.$extendPath('/products/whole-life-critical-illness', '/' + this.simpleItem.scenario_code),
          productName: this.simpleItem.plan_name,
          insuranceCompany: {
            name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
            code: this.simpleItem.insurer_code,
            logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
            logoAlt: this.simpleItem.insurer_name_first,
          },
          userRating: {
            score: this.simpleItem.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.simpleItem.coverage_score),
            description: this.$t('products.wlci.wlci_wholeLifeCICoverageScore'),
            toolTipHtml: this.getTooltipContentByKey('wlci_wholeLifeCICoverageScore'),
          },
          features: [
            {
              text: this.simpleItem.multiple_claim,
              type: 'multiple_claims',
            },
          ],
          keyItems: [
            {
              value: this.$formatScore(this.simpleItem.terms_score),
              key: this.$t('products.wlci.wlci_termsScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('wlci_termsScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.simpleItem.payment_term,
              key: this.$t('products.wlci.wlci_premiumTermYears'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(this.simpleItem.annual_premium),
              key: this.$t('products.wlci.wlci_annualPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: this.getTooltipContentByKey('wlci_annualPremium'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          compactKeyItems: [
            {
              value: this.$formatPrice(this.simpleItem.annual_premium),
              key: this.$t('products.wlci.wlci_annualPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: this.getTooltipContentByKey('wlci_annualPremium'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(this.simpleItem.terms_score) + ' / <small>10</small>',
              key: this.$t('products.wlci.wlci_termsScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('wlci_termsScore'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          promotion: {
            category: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: this.simpleItem.product_promotion?.id,
            scenarioId: this.simpleItem.scenarioID,
            lastCall: this.simpleItem.promotion_last_call

          },
          mainButtonCTA: {
            text: this.simpleItem.decoder_cta_text,
            link: this.simpleItem.decoder_cta_link,
          },
        }
      }
      return null
    },
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'Wlci');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getScore(product) {
      return product.rating.toFixed(1);
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace("$num", renewalTerm);
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    unfavourite() {
      this.product = null;
    },
  },
}
